export const getResetPasswordRedirect = () => {
  const site =
    (process.env.REACT_APP_SITE_URL || "").replace(/\/+$/, "") ||
    (typeof window !== "undefined" ? window.location.origin : "");

  if (!site) return undefined;
  return `${site}/reset-password`;
};
